import { SurveyConfigModule } from "@max/common/setfan";
import { SurveyResponse } from "@max/common/functions/setfan";
import {
  HeadlineText,
  QuestionContainer,
  useDataContext,
  useSurveyContext,
  useValidation,
  Validation,
} from "Components";
import { TextInput } from "melodies-source/TextInput";

export const EmailQuestion = ({
  id,
  style,
  header,
  validation,
}: SurveyConfigModule) => {
  const { setEmail } = useSurveyContext();
  const { data, setData } = useDataContext();
  const d = data?.[id] as SurveyResponse<string>;
  const handleChange = (text: string) => {
    setData({
      ...data,
      [id]: {
        ...d,
        value: text,
      },
    });
    setEmail(text);
  };
  const valid = useValidation(id, validation);

  return (
    <QuestionContainer noBorder>
      <HeadlineText {...header} />
      <TextInput
        type="email"
        value={d?.value || ""}
        onChange={handleChange}
        style={{ ...style, marginTop: 10 }}
        placeholder="Email"
      />
      {valid && <Validation>{valid}</Validation>}
    </QuestionContainer>
  );
};
